<div class="container">

  <div class="content">
    <pdf-viewer
      *ngIf="url"
      [src]="url"
      class="pdf-viewer"
      [render-text]="false"
      [fit-to-page]="false"
      [zoom]="zoom"
      [zoom-scale]="'page-width'"    
      [rotation]="0"
      [show-all]="true"
      [autoresize]="true"
      [show-borders]="false"
      [stick-to-page]="true"
      [original-size]="true"
    ></pdf-viewer>
    <div class="confidential">
        <div class="watermark">
            <h1> Confidential</h1>
            <p>{{email}}</p>

        </div>

    </div>

    <!-- 
  

    
 

    [external-link-target]="'blank'"

     -->
    <div class="zoom-buttons">
      <mat-icon (click)="incrementZoom(0.1)">zoom_in</mat-icon>
      <mat-icon (click)="incrementZoom(-0.1)">zoom_out</mat-icon>
    </div>
  </div>
</div>
